import { render, staticRenderFns } from "./StaffListIntro.vue?vue&type=template&id=86992cd2&scoped=true&"
import script from "./StaffListIntro.vue?vue&type=script&lang=js&"
export * from "./StaffListIntro.vue?vue&type=script&lang=js&"
import style0 from "./StaffListIntro.vue?vue&type=style&index=0&id=86992cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86992cd2",
  null
  
)

export default component.exports